import { render, staticRenderFns } from "./room-publish.vue?vue&type=template&id=6954342b&scoped=true"
import script from "./room-publish.vue?vue&type=script&lang=js"
export * from "./room-publish.vue?vue&type=script&lang=js"
import style0 from "./room-publish.vue?vue&type=style&index=0&id=6954342b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6954342b",
  null
  
)

export default component.exports